var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 33,
    viewBox: "0 0 48 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2006_2095",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 0.5H4C1.79086 0.5 0 2.29086 0 4.5V28.5C0 30.7091 1.79086 32.5 4 32.5H44C46.2091 32.5 48 30.7091 48 28.5V4.5C48 2.29086 46.2091 0.5 44 0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2006_2095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 1.5H44C45.6569 1.5 47 2.84315 47 4.5V28.5C47 30.1569 45.6569 31.5 44 31.5H4C2.34315 31.5 1 30.1569 1 28.5V4.5C1 2.84315 2.34315 1.5 4 1.5Z",
    fill: "white",
    stroke: "#F0F0F0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 11.167H0V21.8337H48V11.167Z",
    fill: "#0C47B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 21.833H0V32.4997H48V21.833Z",
    fill: "#E53B35"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuFlag);
export default __webpack_public_path__ + "static/media/ru_flag.ece5ee723bb48b298daf25193a50d15c.svg";
export { ForwardRef as ReactComponent };